import script from "./DropdownMenuRadioItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./DropdownMenuRadioItem.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__